import api from '@/api'

/**
 * Laravel will convert objects into arrays when there is no data
 * this just screws up everything randomly, we fix this here
 * [] !== {}
 */
export default {
	methods: {
		/**
		 * Checks if the data is an array or object
		 * Checks if object has any value at all
		 * Checks if array or object has items in it
		 *
		 * @param obj
		 * @param objDefault
		 * @returns {boolean|*}
		 */
		exists (obj, objDefault = {}) {
			if (!obj) {
				return false
			}

			if (Array.isArray(obj)) {
				if (obj.length <= 0) {
					return objDefault
				}

				return obj.length > 0
			}

			if (Object.keys(obj).length <= 0) {
				return objDefault
			}

			return Object.keys(obj).length > 0
		},

		/**
		 * Counts items in array or object
		 * If object contains "data" we will assume that is the collection
		 *
		 * @param obj
		 * @returns {number|*}
		 */
		length (obj) {
			if (!obj) {
				return 0
			}

			if (obj.hasOwnProperty('data')) {
				obj = obj.data
			}

			if (Array.isArray(obj)) {
				return obj.length
			}

			return Object.keys(obj).length
		},

		/**
		 * Get the error message for specific form helper field
		 *
		 * @param obj
		 * @param key
		 * @param bag
		 * @returns {*[]|*}
		 */
		errorMsg (obj, key, bag = null) {
			let errors

			if (!obj) {
				return []
			}

			if (! obj.hasOwnProperty('errors')) {
				return []
			}

			if (bag) {
				if (obj.errors.hasOwnProperty(bag)) {
					const errorBag = obj['errors'][bag]
					if (errorBag.hasOwnProperty(key)) {
						errors = errorBag[key]
					}
				}
			}

			if (obj['errors'].hasOwnProperty(key)) {
				errors = obj['errors'][key]
			}

			if (! errors) {
				return []
			}

			if (typeof errors !== 'object') {
				return [errors]
			}

			return errors
		},

		/**
		 * Check if form helper array has errors
		 *
		 * @param obj
		 * @param key
		 * @param bag
		 * @returns {boolean}
		 */
		hasErrors (obj, key, bag = null) {
			if (!obj) {
				return false
			}

			if (! obj.hasOwnProperty('errors')) {
				return false
			}

			if (bag) {
				if (obj.errors.hasOwnProperty(bag)) {
					const errorBag = obj['errors'][bag]
					if (errorBag.hasOwnProperty(key)) {
						return true
					}
				}
			}

			return obj['errors'].hasOwnProperty(key)
		},

		/**
		 * Converts array from server to selectable options
		 *
		 * @param object
		 */
		convertArrayToSelect (object) {
			let selection = []

			for (const objectKey in object) {
				if (!object.hasOwnProperty(objectKey)) continue
				selection.push({
					text: object[objectKey],
					value: objectKey
				})
			}

			return selection
		},

		qString (url, params) {
			return url + '/?' + Object.keys(params).map((key) => {
				return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
			}).join('&')
		},

		getClients (params = {}) {
			const method = 'GET'
			const url = this.route('clients.api.index', params)

			api({
				method,
				url
			}).then(response => {
				this.clients = response.data
			})
		},

		getUserTypes () {
			const method = 'GET'
			const data = {}

			const url = this.route('users.api.types')

			return api({
				method,
				url,
				data
			}).then(response => {
				this.types = response.data
			})
		}
	}
}
